module.exports = __webpack_public_path__ + "static/media/icon_curriculum.9ad564f9.svg";